import { makeStyles } from "@material-ui/core";
import React, { useRef } from "react";
import "./style.css";

const useStyles = makeStyles();

function ToggleBtn({
  styleType,
  label,
  handleToggle,
  handleToggleRef,
  toggleState,
  field,
  backgroundStyle,
  externalStyling,
  handleCaching,
  index,
  widthMin
}) {
  const tglRef = useRef(null);
  return (
    <div
      className={"toggleBtn toggleBtn_iDes" + " " + (externalStyling ? externalStyling.toggle : "") + " control-class"}
    >
      <span>{label}</span>
      <div className={widthMin ? "slideBar minWidth" : "slideBar"}>
        <label
          className={
            widthMin
              ? "switch" + " " + "WidthUnset" + " " + (externalStyling ? externalStyling.center : "")
              : "switch" + " " + (externalStyling ? externalStyling.center : "")
          }
        >
          <span style={{ width: 0, display: "table-column" }}>.</span>

          {toggleState + "" === "true" ? (
            <input
              aria-label={"Show Progress 1"}
              ref={tglRef}
              type="checkbox"
              defaultChecked="true"
              name="showProgress"
              tabIndex={-1}
              onClick={(e) => {
                handleToggle && handleToggle(e, field);
                handleCaching && handleCaching(index);
              }}
              value={"false"}
            />
          ) : (
            <input
              aria-label={"Show Progress 2"}
              ref={tglRef}
              type="checkbox"
              name="showProgress"
              checked={false}
              value={"true"}
              tabIndex={-1}
              onClick={(e) => {
                handleToggle && handleToggle(e, field);
                handleCaching && handleCaching(index);
              }}
            />
          )}
          <span
            tabIndex={0}
            className={
              styleType === "2"
                ? "slider2 slider round"
                : "slider round" + " " + (externalStyling ? externalStyling.input : "")
            }
            onClick={(e) => {
              handleToggleRef && handleToggleRef(tglRef, field);
            }}
            style={backgroundStyle}
          ></span>
          {styleType === "3" && <span className="sliderText"></span>}
        </label>
      </div>
    </div>
  );
}

export default ToggleBtn;
